import { Component, OnInit } from '@angular/core';
import { UrlViewerProvider
 } from '../url-viewer.provider';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomainService } from '@services/domain/domain.service';
import { FeedbackSurvey } from '@models';

@Component({
  selector: 'app-url-viewer-feedback',
  imports: [],
  templateUrl: './url-viewer-feedback.component.html',
  styleUrl: './url-viewer-feedback.component.scss'
})
export class UrlViewerFeedbackComponent implements OnInit {

  constructor(
    private urlViewerProvider: UrlViewerProvider,
    public activeModal: NgbActiveModal,
    public domainService: DomainService,
    ) { }

  public feedbackSurveyQuestions = [];
  public feedbackSurvey: FeedbackSurvey;

  public ratingOptions = [
    { value: 1, label: 'Strongly disagree' },
    { value: 2, label: 'Disagree' },
    { value: 3, label: 'Neither agreen nor disagree' },
    { value: 4, label: 'Agree' },
    { value: 5, label: 'Strongly Agree'},
  ];

  public ratingOptionsOld = [
    { value: 1, label: 'Low Score' },
    { value: 2, label: '' },
    { value: 3, label: 'Medium' },
    { value: 4, label: '' },
    { value: 5, label: 'High Score'},
  ];


  ngOnInit(): void {
    console.log('feedback survey init');
    this.domainService.activeDomain.subscribe({
      next: (domain) => {
        if (domain) { this.feedbackSurvey = domain.feedbackSurveys[0]; }
        if (this.feedbackSurvey) {
          this.feedbackSurveyQuestions = this.feedbackSurvey.feedbackSurveyQuestions;
          console.log(this.feedbackSurveyQuestions)
          console.log(this.feedbackSurveyQuestions[0].feedbackQuestion)
        }
      }
    });
  }

  setFeedbackAnswer(questionId: string, value: any) {
    console.log('setFeedbackAnswer: questionId: ' + questionId + ', value: ' + value);
  }

  closeModel() {
    //this.activeModal.close();
  }

}
